import React from 'react';
import ReactDOM from 'react-dom';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';

import App from './App';
import * as serviceWorker from './serviceWorker';
import msalConfigLoader, { msal, redirectUri } from '@config/msalConfig';

declare global {
    namespace NodeJS {
        interface ProcessEnv {
            REACT_APP_MOCK_SERVER_API_URL: string;
            PORT: string;
            DEV: boolean;
            SASS_PATH: string;
            REACT_APP_ADAL_INSTANCE: string;
            REACT_APP_TCMS_BASE_API_URL: string;
            REACT_APP_TCMS_API_URL: string;
            REACT_APP_PMS_API_URL: string;
            REACT_APP_TENANT: string;
            REACT_APP_TCMS_CLIENT_ID: string;
            REACT_APP_PMS_CLIENT_ID: string;
        }
    }
}

msalConfigLoader.then(() => {
    if (process.env.REACT_APP_DEV) {
        ReactDOM.render(
            // ToDo errors when using Eniram common ui lib in strict mode
            <App />,
            document.getElementById('root')
        );
        return;
    }

    ReactDOM.render(
        <MsalProvider instance={msal.instance}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={{
                    scopes: msal.scopes,
                    redirectStartPage: redirectUri
                }}
            >
                <App />
            </MsalAuthenticationTemplate>
        </MsalProvider>,
        document.getElementById('root')
    );
});

serviceWorker.unregister();
